import {useEffect} from "react";

const VISUAL_VIEWPORT_HEIGHT_VARIABLE = "--search-combobox-vvh";

/**
 * While enabled, keeps `--search-combobox-vvh` on `document.documentElement` equal to `visualViewport.height` in px
 * (resize and scroll events) and removes it when disabled or unmounted. iOS does not shrink `100dvh` when the
 * on-screen keyboard opens, the visual viewport does - the layer uses the variable to keep its footer above it.
 */
export const useVisualViewportHeight = (enabled: boolean): void => {
    useEffect(() => {
        const viewport = typeof window !== "undefined" ? window.visualViewport : null;

        if (!enabled || !viewport) {
            return;
        }

        const rootStyle = document.documentElement.style;
        let lastValue: string | null = null;

        const update = () => {
            const value = `${viewport.height}px`;

            // Scroll fires often while the keyboard animates; skip the style write when nothing changed.
            if (value !== lastValue) {
                lastValue = value;
                rootStyle.setProperty(VISUAL_VIEWPORT_HEIGHT_VARIABLE, value);
            }
        };

        update();
        viewport.addEventListener("resize", update);
        viewport.addEventListener("scroll", update);

        return () => {
            viewport.removeEventListener("resize", update);
            viewport.removeEventListener("scroll", update);
            rootStyle.removeProperty(VISUAL_VIEWPORT_HEIGHT_VARIABLE);
        };
    }, [enabled]);
};
import {useEffect} from "react";

const VISUAL_VIEWPORT_HEIGHT_VARIABLE = "--search-combobox-vvh";

/**
 * While enabled, keeps `--search-combobox-vvh` on `document.documentElement` equal to `visualViewport.height` in px
 * (resize and scroll events) and removes it when disabled or unmounted. iOS does not shrink `100dvh` when the
 * on-screen keyboard opens, the visual viewport does - the layer uses the variable to keep its footer above it.
 */
export const useVisualViewportHeight = (enabled: boolean): void => {
    useEffect(() => {
        const viewport = typeof window !== "undefined" ? window.visualViewport : null;

        if (!enabled || !viewport) {
            return;
        }

        const rootStyle = document.documentElement.style;
        let lastValue: string | null = null;

        const update = () => {
            const value = `${viewport.height}px`;

            // Scroll fires often while the keyboard animates; skip the style write when nothing changed.
            if (value !== lastValue) {
                lastValue = value;
                rootStyle.setProperty(VISUAL_VIEWPORT_HEIGHT_VARIABLE, value);
            }
        };

        update();
        viewport.addEventListener("resize", update);
        viewport.addEventListener("scroll", update);

        return () => {
            viewport.removeEventListener("resize", update);
            viewport.removeEventListener("scroll", update);
            rootStyle.removeProperty(VISUAL_VIEWPORT_HEIGHT_VARIABLE);
        };
    }, [enabled]);
};
